import { FREE_PRODUCT_LIMIT, ORDERS_PRO_ONLY, PRO_PRICE, PRO_TRIAL_DAYS } from '../plans.js';

const PRO_PERKS = (ORDERS_PRO_ONLY ? "productos ilimitados, pedidos por WhatsApp, " : "productos ilimitados, ") + "estadísticas, etiquetas, agotados, foto de portada y tu menú sin la marca de MiQRapp";

// Donde el suscriptor ve, pausa o cancela su suscripción. MiQRapp no guarda datos de la tarjeta.
const MP_SUBSCRIPTIONS_URL = "https://www.mercadopago.com.ar/subscriptions";

// Muestra el plan actual en el panel. En el plan Gratis ofrece pasarse a Pro.
const PlanBanner = ({subscribed, subscriptionStatus, productCount, subscribing, handleSubscribe}) => {

  if (subscribed) {
    return (
      <section className='lp-panel-card lp-panel-stack'>
        <div className='lp-panel-card-head'>
          <h2>Tu plan</h2>
          <span className='lp-panel-badge lp-panel-badge-ok'><span aria-hidden="true"></span>Pro activo</span>
        </div>
        <p><strong>{PRO_PRICE} / mes</strong> con Mercado Pago</p>
        <p className='lp-panel-muted'>Tenés {PRO_PERKS}.</p>
        <a className='lp-text-link lp-panel-left' href={MP_SUBSCRIPTIONS_URL} target="_blank" rel="noreferrer">Gestionar el pago en Mercado Pago</a>
      </section>
    )
  }

  const used = Math.min(productCount, FREE_PRODUCT_LIMIT);
  const reachedLimit = productCount >= FREE_PRODUCT_LIMIT;

  return (
    <section className='lp-panel-card lp-panel-stack'>
      <div className='lp-panel-card-head'>
        <h2>Tu plan</h2>
        <span className='lp-panel-badge'>Gratis</span>
      </div>
      <div>
        <p><strong>{used} de {FREE_PRODUCT_LIMIT} productos</strong>{reachedLimit ? ". Llegaste al límite." : ""}</p>
        <div className='lp-panel-meter' role="progressbar" aria-label="Productos cargados" aria-valuemin={0} aria-valuemax={FREE_PRODUCT_LIMIT} aria-valuenow={used}>
          <span style={{width: `${(used / FREE_PRODUCT_LIMIT) * 100}%`}}></span>
        </div>
      </div>
      {subscriptionStatus === "cancelled" &&
        <p className='lp-panel-muted'>Tu suscripción Pro está cancelada. Podés volver a activarla cuando quieras.</p>
      }
      <p className='lp-panel-muted'>Con Pro tenés {PRO_PERKS}. Probalo {PRO_TRIAL_DAYS} días gratis, después {PRO_PRICE}/mes con Mercado Pago.</p>
      <button type="button" className='lp-btn lp-btn-green' disabled={subscribing} onClick={() => handleSubscribe()}>
        {subscribing ? "Abriendo Mercado Pago..." : `Probar Pro ${PRO_TRIAL_DAYS} días gratis`}
      </button>
    </section>
  )
}

export default PlanBanner
